import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import InputField from '../../inputField';
import ActionButton from '../../actionButton';
import { ACTION_BUTTON_TYPES } from '../../actionButton/config';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
  },
  error: {
    position: 'absolute',
    bottom: -20,
  },
  field: {
    display: 'grid',
    gridTemplateColumns: '1fr 30px',
    gridColumnGap: 6,
    alignItems: 'center',
    width: '100%',
    position: 'relative',
  },
}));

const CreatableText = ({
  translations,
  index,
  text,
  field,
  isDisabled,
  error = null,
  onDelete,
  onChange,
}) => {
  const classes = useStyles();

  const handleChange = useCallback(
    event => {
      onChange(index, { ...text, [field.name]: event.target.value });
    },
    [index, text, field, onChange]
  );

  const handleDelete = useCallback(() => onDelete(text), [text, onDelete]);

  return (
    <div className={classes.root}>
      <div className={classes.field}>
        <InputField
          customErrorClass={classes.error}
          id={field.name}
          name={field.name}
          type={field.type}
          placeholder={translations.fieldLabels[field.name].placeholder}
          required={field.required}
          value={text[field.name]}
          error={!!error?.[field.name]}
          errorMessage={
            translations.fieldLabels.fieldValidationMessages?.[
              error?.[field.name]
            ]
          }
          onChange={handleChange}
          fullWidth
        />
        <ActionButton
          type={ACTION_BUTTON_TYPES.DELETE_FILL}
          disabledTooltipText={translations.disabledReasonDeleteText}
          isDisabled={isDisabled}
          onClickHandler={handleDelete}
        />
      </div>
    </div>
  );
};

CreatableText.propTypes = {
  translations: PropTypes.object.isRequired,
  text: PropTypes.object.isRequired,
  field: PropTypes.object.isRequired,
  error: PropTypes.object,
  onDelete: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default CreatableText;
